export default {
    title: 'THIS PAGE IS UNDER MAINTENANCE',
    subtitle: 'WE WILL BE BACK SHORTLY',
    dont_show_again: "Don't show again",
    until: 'until',
    system_maintenance_scheduled_on: 'System Maintenance scheduled',
};
